import { createReducer, createActions } from 'reduxsauce'

// Action Types & Creators
export const { Types, Creators } = createActions({
  filterClean: [],
  setDeclarationFilter: [],
});

// Handlers
const INITIAL_STATE = {
  filter: {
    status: '',
    fornecedor: {
      nome: '',
    },
    pedido: {
      id: '',
      data: ''
    },
    declaracao: {
      status: '',
      data: ''
    }, 
    orderBy: "pedido asc"  
  }
};

function declarationFilterClean(state = INITIAL_STATE, action) {
  return { ...INITIAL_STATE }
}

function setDeclarationFilter(state = INITIAL_STATE, action) {
  return { 
    ...state,
    filter: action.filter,
  }
}

// Reducer
export default createReducer(INITIAL_STATE, {
  DECLARATION_FILTER_CLEAN: declarationFilterClean,
  [Types.SET_DECLARATION_FILTER]: setDeclarationFilter,
});
